<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="priceChange">
            <van-nav-bar
                left-arrow
                @click-left="onClickLeft"
            >
                <template #title>
                    <span>价格变更表</span>
                </template>
                <template #right>
                    <span class="iconfont iconicon-test" @click="newlyAdded"></span>
                </template>
            </van-nav-bar>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        :immediate-check="false"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <template v-for="(item,index) in listData">
                                <li :key="index" @click="viewDetails(item)">
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span class="headerName">合同编号：{{ item.contract_no }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>相关原材料：{{ item.type_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>相关场站：{{ item.station_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                <span>申请时间：{{ item.apply_date }}</span>
                                            </p>
                                        </div>
                                        <span
                                            class="state returned iconfont iconjiaobiao"
                                            v-if="item.approval_status == -3"
                                        ><i>已退回</i></span>
                                        <span
                                            class="state saved iconfont iconjiaobiao"
                                            v-if="item.approval_status == -2"
                                        ><i>已保存</i></span>
                                        <span
                                            class="state submitted iconfont iconjiaobiao"
                                            v-if="item.approval_status == -1 || item.approval_status == 0 || item.approval_status == 1"
                                        ><i>已提交</i></span>
                                        <span
                                            class="state reviewed iconfont iconjiaobiao"
                                            v-if="item.approval_status == 2"
                                        ><i>已审核</i></span>
                                    </div>
                                    <div class="btns">
                                        <button>
                                            <span>查看明细</span>
                                            <i class="iconfont iconxiangyou"></i>
                                        </button>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
export default {
    // 价格变更
    name: 'price-change',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'price-change');
        }
        next();
    },
    data() {
        return {
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否加载完数据
            finished: false,
            // 当前页码
            pageIndex: 0,
            // 列表数据
            listData: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        this.pageIndex = 0;
        this.pageIndex++;
        this.getListData();
    },
    activated() {
        // isSubmit提交后刷新
        if (this.$route.params.isSubmit) {
            this.pageIndex = 1;
            this.listData = [];
            this.finished = false;
            this. isLoading = true;
            this.isUpLoading = false;
            this.getListData();
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 下拉刷新
        onRefresh() {
            this.pageIndex = 1;
            this.listData = [];
            this.finished = false;
            this. isLoading = true;
            this.isUpLoading = false;
            this.getListData();
        },
        // 上拉加载更多
        onLoad() {
            this. isLoading = false;
            this.isUpLoading = true;
            this.pageIndex++;
            this.getListData();
        },
        // 获取列表数据
        getListData() {
            this.$axios
                .get(`/interfaceApi/Procurement/material/price/adjust/getpage?pageindex=${this.pageIndex}&pagesize=4`)
                .then(res => {
                    if (res.rows.length > 0) {
                        this.listData.push(...res.rows);
                        this.finished = false;
                    } else {
                        this.finished = true;
                    }
                    this. isLoading = false;
                    this.isUpLoading = false;
                })
                .catch(error => {
                    this. isLoading = false;
                    this.isUpLoading = false;
                    this.$toast({ message: error.ErrorCode.Message });
                });
        },
        // 查看详情
        viewDetails(item) {
            this.$router.isBack = 2;
            if (item.approval_status === -3 || item.approval_status === -2) {
                this.$router.push({
                    name: 'newPriceAdjustment',
                    params: {
                        editData: item,
                    },
                });
            } else {
                this.$router.push({
                    name: 'priceChangeDetails',
                    params: {
                        data: item,
                    },
                });
            }
        },
        // 新增调价
        newlyAdded() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'newPriceAdjustment',
                params: {},
            });
        },
    },
};
</script>
<style lang="stylus">
.priceChange
    height 100%
    .van-nav-bar
        display flex
        .van-nav-bar__right
            right 0rpx
            top 0
            span
                color #fff
    section
        height calc(100% - 45rpx)
        .van-pull-refresh
            height 100%
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            .list
                height 100%
                overflow-y auto
                background #F0F0F0
                padding 0 15rpx
                padding-bottom 0
                li
                    width 100%
                    background #fff
                    overflow hidden
                    margin-bottom 15rpx
                    position relative
                    &:first-child
                        margin-top 15rpx
                    .engineeringInfo
                        position relative
                        padding 15rpx
                        padding-bottom 0
                        img,span
                            float left
                            height 16rpx
                            line-height 16rpx
                        img
                            width 16rpx
                            margin-right 12rpx
                        h4,p
                            overflow hidden
                        h4
                            margin-bottom 14rpx
                            width calc(100% - 20rpx)
                            span
                                display inline-block
                                width 100%
                                font-size 18rpx
                                height 20rpx
                                line-height 20rpx
                                color #061F3E
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                                &:before
                                    font-size 20rpx
                                    margin-right 10rpx
                                    color #5588F1
                        p
                            margin-bottom 14rpx
                            span
                                display inline-block
                                width calc(100% - 40rpx)
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                                font-size 14rpx
                                color #666666
                        .state
                            position absolute
                            top 0
                            right 0
                            font-weight 400
                            width 50rpx
                            height 50rpx
                            &:before
                                font-size 50rpx
                                line-height 50rpx
                                color #FF6600
                                position absolute
                                top 0px
                                right 0
                            i
                                position absolute
                                width 40rpx
                                text-align center
                                font-size 12rpx
                                color #FFFFFF
                                transform rotate(45deg)
                                top 12rpx
                                left 12rpx
                            &.returned
                                &:before
                                    color #979EA7
                            &.saved
                                &:before
                                    color #3495FB
                            &.submitted
                                &:before
                                    color #00A84B
                            &.reviewed
                                &:before
                                    color #02ADBE
                    .btns
                        padding 5rpx 15rpx 8rpx
                        border-top 1px solid #F0F0F0
                        text-align center
                        button
                            border none
                            background none
                            color #5494F3
                            font-size 14rpx
                            line-height 16rpx
                            .iconfont
                                font-size 14rpx
                                margin-left 5rpx
</style>